import {
    NEWS_COVER_EMBED_PROVIDER,
    NEWS_COVER_MEDIA_TYPE,
    NEWS_COVER_SOURCE,
    getNewsVideoEmbedData,
} from '@containers/Art/News/News.constants';

export const GALLERY_MEDIA_SOURCE = {
    EMBED: NEWS_COVER_SOURCE.EMBED,
    NETWALK: NEWS_COVER_SOURCE.NETWALK,
    UPLOAD: NEWS_COVER_SOURCE.UPLOAD,
    UPLOADED: NEWS_COVER_SOURCE.UPLOADED,
};

export const GALLERY_MEDIA_TYPE = {
    IMAGE: NEWS_COVER_MEDIA_TYPE.IMAGE,
    VIDEO: NEWS_COVER_MEDIA_TYPE.VIDEO,
};

export const GALLERY_EMBED_PROVIDER = {
    VIMEO: NEWS_COVER_EMBED_PROVIDER.VIMEO,
    YOUTUBE: NEWS_COVER_EMBED_PROVIDER.YOUTUBE,
};

export const GALLERY_MEDIA_SOURCE_OPTIONS = [
    { value: GALLERY_MEDIA_SOURCE.UPLOAD, label: 'New upload' },
    { value: GALLERY_MEDIA_SOURCE.UPLOADED, label: 'Uploaded' },
    { value: GALLERY_MEDIA_SOURCE.NETWALK, label: 'Netwalk media' },
    { value: GALLERY_MEDIA_SOURCE.EMBED, label: 'Vimeo/YouTube' },
];

export const normalizeGalleryMediaType = (mediaType) => {
    return mediaType === GALLERY_MEDIA_TYPE.VIDEO ? GALLERY_MEDIA_TYPE.VIDEO : GALLERY_MEDIA_TYPE.IMAGE;
};

export const getGalleryMediaType = (media = {}) => {
    if (media.MediaType) {
        return normalizeGalleryMediaType(media.MediaType);
    }
    if (media.Source === GALLERY_MEDIA_SOURCE.EMBED) {
        return GALLERY_MEDIA_TYPE.VIDEO;
    }
    if (media.EmbedUrl || media.VideoUrl) {
        return GALLERY_MEDIA_TYPE.VIDEO;
    }
    return GALLERY_MEDIA_TYPE.IMAGE;
};

export const getGalleryVideoEmbedData = (value) => {
    return getNewsVideoEmbedData(value);
};
